import { sizeNomenclatureProject } from "../types/forms";

export const nomenclaturaTotal = (number) => {
	const { XS, S, M, L, XL, XXL } = sizeNomenclatureProject;
	let numenclatura = XS.name;
	if (number >= 0 && number <= 80) {
		numenclatura = XS.name;
	} else if (number >= 81 && number <= 150) {
		numenclatura = S.name;
	} else if (number >= 151 && number <= 350) {
		numenclatura = M.name;
	} else if (number >= 351 && number <= 500) {
		numenclatura = L.name;
	} else if (number >= 501 && number <= 999) {
		numenclatura = XL.name;
	} else if (number >= 1000) {
		numenclatura = XXL.name;
	}
	return numenclatura;
};

export const numberCheckFormProject = (object = {}, name = "", number = 0) => {
	let numberObject = object[name];
	if (numberObject !== number) {
		numberObject = number;
	}
	return numberObject;
};

export const sumTotalHoursProject = (object = {}) => {
	let sum = 0;
	for (const key in object) {
		if (Object.hasOwnProperty.call(object, key)) {
			sum += object[key];
		}
	}
	return { number: sum };
};

export const remainingHoursDevelopByTotalHours = (object = {}, hoursDevelop = 0) => {
	let sum = 0;
	let rest = 0;
	for (const key in object) {
		if (Object.hasOwnProperty.call(object, key)) {
			if (key !== "planning") {
				sum += object[key];
			}
		}
	}
	rest = hoursDevelop - sum;
	return { number: rest, nomenclature: "n/a" };
};
